import { requestFile } from './client.js';
import { saveBlob, stampedName } from '../utils/csv.js';

// Server-side CSV export.
//
// The point: the backend re-runs the SAME query the table was built from and
// streams every matching row. An export is never limited to the rows the
// browser happened to scroll into — which is what makes "select all 3,400
// matching this filter, now give me the CSV" mean all 3,400.
//
// ``params`` is the very object the page already builds for its fetch, so the
// file and the table can't disagree about what was filtered.
export const exportApi = {
  // dataset: billing_records | push_queue | sites | cost_centers |
  //          labor_metrics | task_mapping | mirror_locations | pay_codes |
  //          hol_overrides | audit_log | alerts
  //
  // body: { params, columns?, record_ids?, exclude_ids? }
  //   columns     — the keys the table is showing, in its order.
  //   record_ids  — Billing Records only: the ticked rows.
  //   exclude_ids — Billing Records only: rows un-ticked after "select all
  //                 matching", i.e. everything EXCEPT these.
  download: async (dataset, body = {}) => {
    const { blob, filename } = await requestFile(`/api/export/${dataset}`, {
      method: 'POST',
      body: JSON.stringify(body),
    });
    saveBlob(filename || stampedName(dataset), blob);
  },
};
